<template>
    <label class="kgr-inputAddon">
        <div
            class="kgr-input"
            style="align-content: center"
        >
            {{ label }}
        </div>
        <div class="kgr-inputAddon__addon kgr-inputAddon__addon--accent">{{ value }}</div>
    </label>
</template>

<script>
export default {
    name: 'PillInfo',
    props: {
        label: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: true,
        },
    },
};
</script>
